import { z } from 'zod';

export const moneyPositiveIntSchema = z
    .number({ required_error: 'укажите цену' })
    .int('цена должна быть целым числом')
    .min(1, 'цена должна быть больше 0');
